<app-page-header [title]="'Details'" [subtitle]="'Manage details for SampleStudio'"></app-page-header>

<div class="mb-6">
    <div class="flex justify-between mb-2">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-search"></p-inputicon>
                <input
                        pInputText
                        id="detail_search"
                        [(ngModel)]="search"
                        (input)="onSearchInputChange()"
                        autocomplete="off"
                />
            </p-iconfield>
            <label for="detail_search">Search detail</label>
        </p-ifta-label>
        <p-button
                label="Add Detail"
                canManageSampleDefinitions
                [hidden]="false"
                icon="pi pi-plus"
                (click)="openCreateDetailDialog()"
        ></p-button>
    </div>

    <div class="border border-gray-300 dark:border-gray-700 p-2 dark:p-0 mb-5 rounded-sm">
        <p-table
                [value]="details"
                [paginator]="true"
                [rows]="rows"
                [totalRecords]="totalRecords"
                [lazy]="true"
                [first]="currentPage * rows"
                [loading]="loading"
                [rowsPerPageOptions]="[5, 10, 20]"
                (onLazyLoad)="onPageChange($event)"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>Naming Relevant</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-detail>
                <tr>
                    <td>{{ detail.name }}</td>
                    <td>{{ detail.isNamingRelevant ? 'Yes' : 'No' }}</td>
                    <td>
                        <div class="flex justify-end">
                            <p-button
                                    icon="pi pi-eye"
                                    text
                                    pTooltip="View detail"
                                    tooltipPosition="left"
                                    routerLink="/details/detail/{{ detail.id }}">
                            </p-button>

                            <p-button
                                    canManageSampleDefinitions
                                    icon="pi pi-pencil"
                                    text
                                    pTooltip="Edit detail"
                                    tooltipPosition="left"
                                    (click)="editDetail(detail)">
                            </p-button>

                            <p-button
                                    canManageSampleDefinitions
                                    icon="pi pi-trash"
                                    text
                                    pTooltip="Delete detail"
                                    tooltipPosition="left"
                                    (click)="deleteDetail(detail)"
                                    severity="danger">
                            </p-button>
                        </div>

                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<!-- Create Detail Dialog -->
<app-create-detail-dialog
        [(visible)]="displayCreateDetailDialog"
        (detailCreated)="reloadDetails()"
></app-create-detail-dialog>

<!-- Update Detail Dialog -->
<app-update-detail-dialog
        [(visible)]="displayUpdateDetailDialog"
        [detail]="selectedDetail"
        (detailUpdated)="reloadDetails()"
></app-update-detail-dialog>
